import { isNull, isString, isUndefined } from 'utils/tsHelpers';
import { isEmptyString } from 'utils/stringHelpers';

import { useTranslation } from './useTranslation';
import { StringValue } from '../domain';
import { isHandlebarSyntax } from '../utils/isHandlebarSyntax';

export const useValidateConditionValue = () => {
  const { t } = useTranslation();
  return (value: unknown) => {
    if (
      isUndefined(value) ||
      isNull(value) ||
      (value instanceof StringValue && isEmptyString(value.value)) ||
      (isString(value) && isEmptyString(value as string))
    ) {
      return t('conditionalContent.conditions.unfulfilledInputs');
    } else if (value instanceof StringValue && isHandlebarSyntax(value.value)) {
      return t('conditionalContent.conditions.handlebarError');
    }
  };
};
